import createFormSlice from '@/store/reducers/createFormSlice';
import { createSlice } from '@reduxjs/toolkit';
import { sendForm } from '@/core/utils/sendFormData';
import API_ENDPOINTS from '../../api/apiConfig';
import { ReportFormTypes } from '@/store/types/ReportFormTypes';

const reportFormData: ReportFormTypes = {
	email: '',
	// Дефолт (первая опция report.type_options) проставляется в ReportForm:
	// на этапе module-eval ленивая локаль ещё не загружена (см. src/i18n.ts).
	type: '',
	question_id: null,
	comment: '',
};

const formSlice = createFormSlice('reportForm', reportFormData);

const combinedSlice = createSlice({
	name: 'reportForm',
	initialState: formSlice.getInitialState(),
	reducers: {
		setReportFormEmail(state, action) {
			state.data.email = action.payload;
		},
		...formSlice.caseReducers,
	},
});

export const {
	resetSuccessMessage,
	setError,
	setReportFormEmail,
} = combinedSlice.actions;

export const sendReport = (data: ReportFormTypes) => sendForm(combinedSlice, API_ENDPOINTS.reportForm, 'validation.success_message')(data);

export default combinedSlice.reducer;
export { combinedSlice as reportFormSlice };
